export class ModuleInput {
    public name: string = '';
}
